module.exports.CONSOLE_VERSION = '6.7.0.1'
module.exports.WI_CONSOLE_VERSION = '1.3.0.109'
